module.exports = __webpack_public_path__ + "280f361613694de111a9033058ed37fa.png";